import * as React from 'react';

const Ee16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1.127 9.673h14V11a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#0072CE", d: "M1.127 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.332h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M1.127 6.333h14v3.334h-14z" }));
Ee16.Size = 16;
Ee16.Title = "Ee";

export { Ee16 as default };
